function Tecnologia(){
    return(

        <span>tecnologia</span>

    )
}
export default Tecnologia